module.exports = __webpack_public_path__ + "static/media/git.d03d8c86.svg";